const ACCESS_TOKEN_KEY = 'aiecom_access_token';
const TENANT_KEY = 'aiecom_tenant_id';
const ORG_KEY = 'aiecom_org_id';
const BRAND_KEY = 'aiecom_brand_id';
const WORKSPACE_KEY = 'aiecom_workspace_id';
const MEMBERSHIP_KEY = 'aiecom_membership_id';

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

/** Explicit tenant from session or VITE env — never invents tenant-a. */
export function getTenantId(): string | null {
  return localStorage.getItem(TENANT_KEY) ?? import.meta.env.VITE_TENANT_ID ?? null;
}

/** Explicit org — never invents org-a. */
export function getOrgId(): string | null {
  return localStorage.getItem(ORG_KEY) ?? import.meta.env.VITE_ORG_ID ?? null;
}

/** Explicit workspace claim — never invents ws-default. */
export function getWorkspaceId(): string | null {
  return localStorage.getItem(WORKSPACE_KEY) ?? import.meta.env.VITE_WORKSPACE_ID ?? null;
}

export function getMembershipId(): string | null {
  return localStorage.getItem(MEMBERSHIP_KEY) ?? null;
}

/**
 * Scope headers for identity chain (ADR-05). Only emit claims that are actually set.
 * Fail-closed: missing X-Tenant-Id → API returns TENANT_MISSING (no silent product defaults).
 */
export function getScopeHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const tenant = getTenantId();
  const org = getOrgId();
  if (tenant) headers['X-Tenant-Id'] = tenant;
  if (org) headers['X-Org-Id'] = org;
  const brand = localStorage.getItem(BRAND_KEY);
  const workspace = getWorkspaceId();
  const membership = getMembershipId();
  if (brand) headers['X-Brand-Id'] = brand;
  if (workspace) headers['X-Workspace-Id'] = workspace;
  if (membership) headers['X-Membership-Id'] = membership;
  const token = getAccessToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

export function setScope(tenant: string, org: string, brand?: string, workspace?: string) {
  localStorage.setItem(TENANT_KEY, tenant);
  localStorage.setItem(ORG_KEY, org);
  if (brand) localStorage.setItem(BRAND_KEY, brand);
  if (workspace) localStorage.setItem(WORKSPACE_KEY, workspace);
}

export function clearScope() {
  [TENANT_KEY, ORG_KEY, BRAND_KEY, WORKSPACE_KEY, MEMBERSHIP_KEY].forEach((k) => localStorage.removeItem(k));
}

export function isAuthenticated(): boolean {
  return !!getAccessToken();
}
